module.exports = __webpack_public_path__ + "img/836.3ca11f96.png";